import React from 'react';
import { Button } from '@material-ui/core';
import FlipCameraIcon from '../../../icons/FlipCameraIcon';
import useFlipCameraToggle from '../../../hooks/useFlipCameraToggle/useFlipCameraToggle';

export default function FlipCameraButton() {
  const { flipCameraDisabled, toggleFacingMode, flipCameraSupported } = useFlipCameraToggle();

  if (!flipCameraSupported) return null;

  return (
    <Button
      onClick={toggleFacingMode}
      startIcon={
        <div style={{ color: '#707578', display: 'flex' }}>
          <FlipCameraIcon />
        </div>
      }
      disabled={flipCameraDisabled}
    >
      Virar câmera
    </Button>
  );
}
